import React, {
    Component,
    PropTypes
} from 'react';
import {
    Link
} from "react-router";
import {getUserId,resultTip,errToSuc,errorShow,successShow,language} from "UTIL/common"
import bumpService from 'SERVICES/purifier/bump/bumpService'
import FormInput from 'CONFIG/component/form/formInput'
import Tip from 'CONFIG/component/tip'
import BoxHeader from "CONFIG/component/boxHeaderCreate"

export default class PparamCreate extends Component {
	constructor(props) {
		super(props);
		this.submit = this.submit.bind(this);
		this.getDate = this.getDate;
		this.onChange = this.onChange.bind(this);
		this.state = {
			frameworkList: [],
			metaList: [],
		}
	}
	componentDidMount() {
		bumpService.pparamAdd().then(data=>{
			console.log(data)
            const list = data.data;
            this.setState({
                frameworkList: list,
            })
            const id = list[0].id;
            this.getDate(id);
		})

	}
	getDate(id) {
		bumpService.pparamGetMetas(id).then(data=>{
            const arr = data.data;
            this.setState({
                metaList: arr
            })
		})
	}
	onChange() {
		const id = $("#pframeworkId").val();
		this.getDate(id);
	}
	submit(event) {
        event.preventDefault();
        errToSuc();
		const arr = {
			"pframeworkId": $("#pframeworkId").val(),
			"paramCode": $.trim($("#paramCode").val()),
			"paramName": $.trim($("#paramName").val()),
			"paramNameEn": $.trim($("#paramNameEn").val()),
			"targetMetaId": $("#targetMetaId").val(),
			"andvalue": $.trim($("#andvalue").val()),
		}
		var errorMessage = '';
        for(let i in arr){
            if(i!='id'){
                if(arr[i] == ''){
                    errorShow(i);
                }
            }
        }
        if($("[name='error']").length == 0){
            const data =JSON.stringify(arr);
            bumpService.pparamInsertOrUpdate({data}).then(body=>{
                resultTip(body,'/config/pparam/pparamIndex')
            });
		}

	}
	render() {
		const frameworkList = this.state.frameworkList.map(function(str, index) {
			return <option value={str.id} key={index} >{str.proName}</option>
		})
		const metaList = this.state.metaList.map(function(str, index) {
			return <option value={str.id} key={index}>{str.name}</option>
		})
		return (
			<div >
				<section className="content-header">
		            <h1> {language()['ProtocolParameter']} <small>{language()['ProtocolParameterAdd']}</small> </h1>
		        </section>
				<section className="content" >
					<div className="box box-primary color-palette-box">
						<BoxHeader name={language()['ProtocolParameterAdd']}/>
						<div className="box-body">
							<Tip ids=""/>
							<form className="form-horizontal">
								<div className="row form-group">
									<label  className="multi-label control-label col-xs-2">{language()['pframework']}</label>
									<div className="col-xs-3">
										<select  className="form-control" id='pframeworkId'>
                                            {frameworkList}
										</select>
									</div>
								</div>
								<FormInput id="paramCode" name="paramCode"/>
								<FormInput id="paramName" name="paramName"/>
								<FormInput id="paramNameEn" name="paramNameEn"/>
								<FormInput id="andvalue" name="andvalue"/>
								<div className="row form-group">
									<label  className="multi-label control-label col-xs-2">{language()['targetMeta']}</label>
									<div className="col-xs-3">
										<select  className="form-control" id='targetMetaId'>
                                            {metaList}
										</select>
									</div>
								</div>
							</form>
						</div>
						<div className="box-footer">
							<div className="col-xs-2"></div>
							<div className="col-xs-1 text-center">
								<Link  to = "/config/pparam/pparamIndex" className="btn btn-default btn-md">
									{language()['return']}
								</Link>
							</div>
							<div className="col-xs-1 text-center">
								<button className="btn btn-success" id="btnSubmit" onClick={this.submit.bind(this)}>{language()['submit']}</button>
							</div>
						</div>
					</div>
				</section>
			</div>

		);
	}
}


// WEBPACK FOOTER //
// ./modules/bump/config/pparam/pparamCreate.js